import * as React from 'react';
import MessageCourier from '../../lib/MessageCourier';
import TimeTaxSupportSystemClient from '../../system';
import { User } from '../../system/User';
import {
  ITreeChartDataPoint,
} from '@fluentui/react-charting';
import { t, } from 'i18next';
import { Slider, DefaultPalette, Dropdown, IDropdownOption } from 'office-ui-fabric-react';
import { ICommandBarItemProps } from '@fluentui/react/lib/CommandBar';
import { titleCommandBarButtonStyles } from '../../styles/button-styles';
import ViewWrapperWithCommandBar from '../Layout/ViewWrapperWithCommandBar';
import { Tree,TreeNode } from 'react-organizational-chart';
import './treeChart.css';

interface ICompanyTreeProps {
  system: TimeTaxSupportSystemClient;
  courier: MessageCourier;
  changeBlockUI: (change: boolean) => void;
  user: User;
}

const nodeStyle: React.CSSProperties = {
  padding: "10px",
  border: "3px solid #007bff",
  borderRadius: "0px",
  backgroundColor: "#fff",
  display: "inline-block",
  color: "black",
  fontWeight: "500",
  textAlign: "center",
  minWidth: "200px",
  maxWidth: "300px",
  wordWrap: "break-word", 
};

const renderTree = (node:ITreeChartDataPoint) => (
  <TreeNode label={<div style={{ ...nodeStyle, border: `3px solid ${node.fill}`}}>{node.name}</div>}>
    {node.children?.map((child, index) => (
      <React.Fragment key={index}>{renderTree(child)}</React.Fragment>
    ))}
  </TreeNode>
);

const CompanyTreeView = (props: ICompanyTreeProps) => {
  const [treeData, setTreeData] = React.useState<ITreeChartDataPoint | undefined>(undefined);
  const [zoom, setZoom] = React.useState<number>(75);
  const [direcciones, setDirecciones] = React.useState<string[]>([]);
  const [direccionSeleccionada, setDireccionSeleccionada] = React.useState<string>('');
  const [refresh, setRefresh] = React.useState<number>(0);

  const itemsMenu = React.useMemo(
      (): ICommandBarItemProps[] => [
        {
          key: 'title',
          text: t('Detalle'),
          iconProps: {
            iconName: 'Backlog',
            color: DefaultPalette.themeLighterAlt,
            className: 'text-title-btn',
          },
          buttonStyles: titleCommandBarButtonStyles,
          className: 'text-title-btn',
        },
        {
          key: 'refresh',
          text: t('Actualizar'),
          iconProps: {
            iconName: 'Refresh',
            color: DefaultPalette.themeLighterAlt,
            className: 'text-title-btn',
          },
          buttonStyles: titleCommandBarButtonStyles,
          onClick: () => {
            setRefresh((prev) => prev + 1);
          },
        },
      ],
      []
  );

  const getInfo = async (refresh: boolean) => {
    props.changeBlockUI(true);

    const [nodes, getlevels] = await Promise.all([
      props.system.getOrganizationChartSystem().getAllNodes(refresh),
      props.system.getOrganizationChartSystem().getLevels(refresh),
    ]);

    if (nodes) {
      const firstLevel = nodes.filter((nodo) => nodo.getLevel().getLevel() === getlevels[0].getLevel());

      setDirecciones(firstLevel.map((nodo) => nodo.getName()));

      const nodeNodeSelect = direccionSeleccionada
          ? nodes.find(
              (nodo) =>
                  nodo.getLevel().getLevel() === getlevels[0].getLevel() &&
                  nodo.getName() === direccionSeleccionada
          )
          : nodes.find(
              (nodo) =>
                  nodo.getLevel().getLevel() === getlevels[0].getLevel() &&
                  nodo.getName() === firstLevel[0].getName()
          );

      if (nodeNodeSelect) {

        setTreeData(undefined);

        let nodeEncont: any[] = [];

        const reversedLevels = [...getlevels].sort((a, b) => b.getLevel() - a.getLevel());
        
        let rootTree: any | null = null;
        
        reversedLevels.forEach((level) => {

          if (level.getLevel() !== 1) {

            const nodesAtLevel = nodes.filter(
              (nodo) => nodo.getLevel().getLevel() === level.getLevel()
            );
            
            const mappedNodes: any[] = nodesAtLevel.map((nodo) => ({
              name: nodo.getName(),
              children: nodeEncont.filter((child) => child.node.isDescendantOf(nodo)),
              node: nodo,
              fill:getLighterBlue(nodo.getLevel().getLevel()*2)
            }));
            nodeEncont = mappedNodes;
          } else {
            rootTree = {
              name: nodeNodeSelect!.getName(),
              children: nodeEncont.filter((child) =>
                child.node.isDescendantOf(nodeNodeSelect!)
              ),
              node: nodeNodeSelect!,
              fill: getLighterBlue(getlevels[0].getLevel()+1)
            };
          }
        });
        
        setTreeData(undefined);
        setTreeData(rootTree)
      }
    }

    props.changeBlockUI(false);
  };

  React.useEffect(() => {
     getInfo(false);
  }, [direccionSeleccionada]);

  React.useEffect(() => {
     getInfo(true)
  }, [refresh]);

  function getLighterBlue(level: number): string {
    const maxLevel = 10;
    const ratio = level / maxLevel;
  
    const red = Math.round(75 * ratio); 
    const green = Math.round(255 * ratio); 
    const blue = 255 - Math.round(100 * ratio);
  
    const toHex = (num: number): string => num.toString(16).padStart(2, '0');
  
    return `#${toHex(red)}${toHex(green)}${toHex(blue)}`;
  }

  const opciones: IDropdownOption[] = React.useMemo(() => {
    const direc = direcciones.map((dir) => {
      return {
        key: dir,
        text: dir,
      };
    });
    /* ORDENAR A - Z */
    return direc.sort((a, b) => a.text.localeCompare(b.text));
  }, [direcciones]);


  const onChange = (_ev, op) => {
    setDireccionSeleccionada(op?.key.toString()!);
   // setTimeout(() => scrollToMiddle(), 20);
  };

  
  return (
      <>
        <ViewWrapperWithCommandBar title="" items={itemsMenu} withBorderBottom>
          <div style={{ width: '300px', padding: 16 }}>
            {direcciones && (
                <Dropdown
                    label={t('Dirección')}
                    selectedKey={direccionSeleccionada ? direccionSeleccionada : direcciones[0]}
                    onChange={onChange}
                    options={opciones}
                    styles={{ dropdown: { marginBottom: '20px' } }}
                    placeholder={t('Seleccione una dirección')}
                />
            )}
            <Slider  label={t('Zoom')}  styles={{ container: { width: 200 } }}  max={100}  min={10}  value={zoom}  showValue  onChange={(val) => setZoom(val)}/>
          </div>
          <div id={'outerTree'} style={{ zoom: +zoom + '%' }}>
            <Tree
              lineWidth={"2px"}
              lineColor={"#000"}
              lineBorderRadius={"10px"}
              label={
              <div style={{ ...nodeStyle, border: `3px solid ${treeData?.fill}`, backgroundColor: "#fff",  minWidth: `${200 + 1 * 20}px`,  maxWidth: `${250 + 2 * 30}px`, }}>  {treeData?.name} </div>}>
                  {treeData?.children?.map((child, index) => (
                    <React.Fragment key={index}>{renderTree(child)}</React.Fragment>
                  ))}
            </Tree>   
          </div>
        </ViewWrapperWithCommandBar>
      </>
  );
};

export default CompanyTreeView;
